<template>
  <div :class="[
    'navbar navbar-guide navbar-dark text-white fixed-bottom py-3',
    barBgClass,
    show ? 'show' : ''
  ]">
    <div class="container-fluid">
      <div class="row flex-grow-1">

        <!-- START large screen version -->
        <div class="d-none d-md-flex col-12">
          <div class="align-self-center" v-if="!hasNext && !hasPrevious && hasTrail">
            <mark-guide-as-read :guide="guide"></mark-guide-as-read>
          </div>

          <div class="align-self-center" v-if="hasNext || hasPrevious">
            <a :href="previous.link" :class="['btn text-nowrap mr-1', buttonClass]" v-if="hasPrevious">
              <i class="fa fa-caret-left mr-2"></i>
              Previous
            </a>
            <a :href="next.link" :class="['btn text-nowrap', buttonClass]" v-if="hasNext">
              Next
              <i class="fa fa-caret-right ml-2"></i>
            </a>
          </div>

          <div
            v-if="hasNext || hasPrevious || hasTrail"
            class="h4 text-white mb-0 align-self-center ml-3 mr-4">|</div>

          <div class="align-self-center">
            <div class="mr-3">
              <i class="fa fa-map-signs mr-1" v-if="hasTrail" />
              <span class="">You are reading:</span>
              <span class="font-weight-bold" v-text="guide.title"></span>
            </div>
          </div>

          <div class="align-self-center ml-auto">
            <a :href="bookmark" :class="['btn text-nowrap', buttonClass]" @click.prevent="scrollToMoreGuides">
              <span v-if="!hasTrail">
                <i class="fa fa-th-list mr-2"></i>
                Related&nbsp;Guides
              </span>
              <span v-if="hasTrail">
                <i class="fa fa-list mr-2"></i>
                Browse&nbsp;Trail
              </span>
            </a>
          </div>
        </div><!-- END large screen version -->

        <!-- START small screen version -->
        <div class="col-12 d-md-none">
          <div class="d-lg-flex align-items-center">
            <div class="small order-3-lg mb-2 mb-lg-0">
              <span class="">You are reading:</span>
              <span class="font-weight-bold" v-text="guide.title"></span>
            </div>
            <div class="d-flex">
              <div class="mr-1" v-if="!hasNext && !hasPrevious && hasTrail">
                <mark-guide-as-read
                  css-class="btn btn-sm text-nowrap btn-flat-wisteria"
                  :guide="guide"
                ></mark-guide-as-read>
              </div>
              <div class="" v-if="hasNext || hasPrevious">
                <a :href="previous.link" :class="['btn text-nowrap mr-1 btn-sm', buttonClass]" v-if="hasPrevious">
                  <i class="fa fa-caret-left mr-1"></i>
                  Previous
                </a>
                <a :href="next.link" :class="['btn text-nowrap btn-sm', buttonClass]" v-if="hasNext">
                  Next
                  <i class="fa fa-caret-right ml-2"></i>
                </a>
              </div>
              <div class="mr-2">
                <a :href="bookmark" :class="['btn btn-link btn-sm text-white text-nowrap text-decoration-none']" @click.prevent="scrollToMoreGuides">
                  <span v-if="!hasTrail">
                    <i class="fa fa-th-list mr-1"></i>
                    Related Guides
                  </span>
                  <span v-if="hasTrail">
                    <i class="fa fa-list mr-1"></i>
                    Browse Trail
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div><!-- END small screen version -->
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#beacon-container { display: none !important; }

.navbar-guide {
  bottom: -200px;
  transition: bottom 0.3s;

  &.show {
    bottom: 0;
  }
}
</style>

<script>
import $ from 'jquery'
import { get } from 'lodash'
import MarkGuideAsRead from './MarkGuideAsRead'

export default {
  components: {
    MarkGuideAsRead
  },
  props: {
    guide: {
      type: Object,
      required: true
    },
    next: {
      type: Object,
      default () {
        return {}
      }
    },
    previous: {
      type: Object,
      default () {
        return {}
      }
    },
    trail: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    hasNext () {
      return !!get(this.next, 'id')
    },
    hasPrevious () {
      return !!get(this.previous, 'id')
    },
    hasTrail () {
      return !!get(this.trail, 'id')
    },
    barBgClass () {
      return this.hasTrail ? 'bg-flat-amethyst' : 'bg-flat-peter-river'
    },
    buttonClass () {
      return this.hasTrail ? 'btn-flat-wisteria' : 'btn-flat-belize-hole'
    },
    bookmark () {
      return this.hasTrail ? '#trail-guides' : '#related-guides'
    }
  },
  mounted () {
    $('body').prepend($(this.$el))
    $(window).scroll(this.handleScroll)
  },
  methods: {
    handleScroll () {
      let $window = $(window)
      let lastTop = null

      let scrollTop = $window.scrollTop()
      let belowTopOfGuide = scrollTop > $('.card-guide').offset().top
      let aboveRelatedGuides = (scrollTop + $window.height()) < $(this.bookmark).offset().top
      let scrollingUp = lastTop > scrollTop
      this.show = (scrollingUp && belowTopOfGuide) || (belowTopOfGuide && aboveRelatedGuides)

      lastTop = scrollTop
    },
    scrollToMoreGuides () {
      $('html, body').animate({ scrollTop: $(this.bookmark).offset().top })
    }
  }
}
</script>